import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useBudgetActionSearchDispatch, useBudgetActionSearchState } from './budget-action-search-context';
import BudgetProgramAppService from '../../../../application/platform/sge/budget-program/budget-program-app-service';

export const useBudgetActionSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useBudgetActionSearchDispatch();
    const state = useBudgetActionSearchState();

    useEffect(() => {
        BudgetProgramAppService.list().then((data) =>
            dispatch({ type: ACTION_TYPES.setBudgetPrograms, payload: data })
        );
    }, []);

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'select-budget-program') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { budgetProgramId: value || undefined } });
        } else if (name === 'input-search') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { search: value || undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { budgetProgramId: undefined, search: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() { navigate('/acoes-orcamentarias/cadastrar'); }
    function navigateToEdit(id: number) { navigate(`/acoes-orcamentarias/editar/${id}`); }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToEdit };
};
